export default __webpack_public_path__ + "static/association-99e737febd0fbc9f7e487b76f7dece42.jpg";